import Player from '@vimeo/player';

export default function VimeoVideo(handle, {
    posterHandle,
    isBackground,
    playheadControlsContextId,
    activeClass,
}) {

    const iframe = handle.querySelector('iframe');
    const player = new Player(iframe);
    
    const poster = handle.querySelector(posterHandle);
    const playheadControlsContext = document.getElementById(playheadControlsContextId);

    const playheadControlsAttr = 'data-video-playhead-control';
    const playheadControlsAttrDataset = 'videoPlayheadControl';
    
    function handlePoster() {
        if (poster === null) return;
        
        player.ready().then(function() {
            handle.classList.add(activeClass);
        });        
    }
    
    function handlePlayheadControls() {
        if (playheadControlsContext === null) return;
        
        const playheadControls = playheadControlsContext.querySelectorAll(`[${playheadControlsAttr}]`);

        // player.on('progress', function(data) {
        //     console.log(data.percent);
        // });

        Array.from(playheadControls).forEach(btn => {
            let seconds = Number(btn.dataset[playheadControlsAttrDataset].replace(/['"]+/g, ''));
            
            btn.addEventListener('mouseenter', function() {
                player.setCurrentTime(seconds * 10).catch(function(error) {
                    switch (error.name) {
                        case 'RangeError':
                            console.log('range error');
                            break;
    
                        default:
                            console.log('other error');
                            break;
                    }
                });
            });
        });
    }

    if (isBackground) {
        handlePoster();
    }
    player.on('bufferend', handlePlayheadControls);
}
